<template>
  <div class="loading">
    <div class="coin_flip_logo">
      <img id="loader" class="dimension" src="../../public/img/logos/logo_symm.png" />
    </div>
  </div>
</template>

<style>
.dimension {
  width: 48px;
  height: 48px;
}
.fadee {
  -webkit-animation: fadeOut 1.5s ease-out; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadeOut 1.5s ease-out; /* Firefox < 16 */
  -ms-animation: fadeOut 1.5s ease-out; /* Internet Explorer */
  -o-animation: fadeOut 1.5s ease-out; /* Opera < 12.1 */
  animation: fadeOut 1.5s ease-out;
}
.coin_flip_logo {
  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}
.loading {
  width: 100%;
  height: 1600px;
  position: absolute;
  top: -100px;
  background-color: #f2f2f2;
  z-index: 99999;
}
</style>

<script>
export default {
  mounted() {}
};
</script>
